import { render, staticRenderFns } from "./RomaUnitList.vue?vue&type=template&id=24eee8b2"
import script from "./RomaUnitList.vue?vue&type=script&lang=ts"
export * from "./RomaUnitList.vue?vue&type=script&lang=ts"
import style0 from "./RomaUnitList.vue?vue&type=style&index=0&id=24eee8b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports